import styled from '@emotion/styled';
import { alpha } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import { shouldForwardProps } from '../../../utils';

const StyledIconButton = styled(IconButton, shouldForwardProps)`
    color: ${({ theme, color }) => color ?? theme.colors.onSurfaceVariant};
    &:hover {
        background-color: ${({ theme }) =>
            alpha(theme.colors.onSurfaceVariant, theme.palette.action?.hoverOpacity ?? 0)};
    }
    border: 2px solid transparent;
    &:focus {
        border: 2px solid ${({ theme }) => theme.colors.white};
        border-radius: 8px;
        box-shadow:
            0 0 0 2px ${({ theme }) => theme.colors.primary},
            0 0 0 4px ${({ theme }) => alpha(theme.colors.primary, 0.4)};
    }
`;

const FilledButtonWrapper = styled(IconButton, shouldForwardProps)<{ isBig?: boolean }>`
    background-color: ${({ theme, disabled }) =>
        disabled ? theme.colors.disabled : theme.colors.primary};
    border-radius: 100px;
    padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};
    height: 40px;
    width: 40px;
    color: ${({ theme }) => theme.colors.onPrimary};
`;

export { StyledIconButton, FilledButtonWrapper };
